import React, { useState, useEffect, useContext, useRef, createRef } from "react";
import Button from "@mui/material/Button";
import Context from "../../../../context/Context";
import { Modal } from "react-bootstrap";
import './styles.css'
import { ReasonModal } from "../ReasonModal";
import blogFetch from "../../../../axios/config";
import toast from "react-hot-toast";
import Loading from "../../../../components/Loading";
import { AnaliseModalObs } from "../AnaliseModalObs";

const statusAprovado = "APROVADO"
const statusAnalise = "ANALISE"

export const ApontModal = ({
  vagaoItens,
  showApont,
  setShowApont,
  setapontButtonEnabled
}) => {

  const [showReason, setShowReason] = useState(false)
  const [clickedItem, setClickedItem] = useState([])
  const [clickedItemKey, setClickedItemKey] = useState(null)
  const [disableButton, setDisableButton] = useState(false)
  const [showObs, setShowObs] = useState(false)
  const [currentItem, setCurrentItem] = useState(null);
  const [currentItemKey, setCurrentItemKey] = useState(null);

  const {
    selectedFurnace,
    setConfirmedWagon,
    status,
    confirmedWagon,
    // getConfirmedWagon,
    loading,
    setLoading
  } = useContext(Context);

  useEffect(() => {
  }, []);

  const handleAddRef = () => {
    return vagaoItens?.map((_) => createRef())
  };

  const inputAPROVADO = useRef(handleAddRef());
  const inputANALISE = useRef(handleAddRef());

  const handleRadio = ({ value }, index, item) => {
    setClickedItemKey(index)
    setClickedItem(item);
    switch (value) {
      case ("APROVADO"):
        inputAPROVADO.current[index].current.checked = true
        inputANALISE.current[index].current.checked = false
        break;
      case "ANALISE":
        inputANALISE.current[index].current.checked = true
        inputAPROVADO.current[index].current.checked = false
        break;
    }
  }

  const getUserMatricula = () => {
    const nro_matricula = JSON.parse(localStorage.getItem('user'))
    const userSAPMatricula = nro_matricula['user_SAPMatricula'];
    return userSAPMatricula
  }

  const FormatVagaoKey = (clickedItem) => {
    return parseInt(clickedItem.vagao_Serial.substring(1), 10);
  }

  const getConfirmedWagon = async (status, selectedFurnace) => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`);
      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image += "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D"
        return item
      })
      setConfirmedWagon(url);
    } catch {
      console.error("Error")
    }
    finally {
    }
  }

  const putAnalisePeca = async (item, obs) => {
    setDisableButton(true)
    try {
      await blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
        Vagao_Key: FormatVagaoKey(item),
        Ordem_Serial: item.ordem_Serial,
        Status: statusAnalise,
        Molde_Key: item.molde_Key,
        Status_Peca: statusAnalise,
        Observacao: obs
      });
      toast.success("Sucesso ao adicionar peça em análise", {
        duration: 4000,
      });
    } catch (e) {
      console.error(e)
      toast.error("Erro ao adicionar peça em análise", {
        duration: 4000,
      });
    } finally {
      setDisableButton(false)
      setShowObs(false)
      await getConfirmedWagon(status, selectedFurnace)
    }
  }

  const putAprovadoPeca = async () => {
    try {
      vagaoItens
        .filter((peca) => !(peca.status_Peca === "ANALISE"))
        .map((peca) => {
          return blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
            Vagao_Key: FormatVagaoKey(clickedItem),
            Ordem_Serial: peca.ordem_Serial,
            Status: statusAprovado,
            Molde_Key: peca.molde_Key,
            Status_Peca: statusAprovado
          });
        });
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const postAprovadoApontamento = async () => {

    const userSAPMatricula = getUserMatricula();

    try {
      vagaoItens
        .filter((peca) => !(peca.status_Peca === "ANALISE"))
        .map((peca) => {
          return blogFetch.post(`ISAGA_ApontamentoSAP?furnace=${selectedFurnace}`, {
            Centro_Trabalho: "06CURVAD",
            Ordem_Fabricacao: peca.ordem_Serial,
            Operacao: "1000",
            Tipo_Apontamento: statusAprovado,
            Chave_Modelo: "SALH",
            Nro_Matricula: userSAPMatricula
          })
        });
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const putAprovadoVagao = async () => {
    try {
      const formData = new FormData();
      formData.append("Vagao_Key", Number(vagaoItens[0].vagao_Serial.replace(/^.| /g, "")));
      formData.append("Status", statusAprovado);
      await blogFetch.put(`/ISAGA_VagoesFornos/status`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    } catch {

    } finally {

    }
  }

  const apontLote = async () => {
    setLoading(true)
    try {
      await postAprovadoApontamento()
      await putAprovadoPeca()
      await putAprovadoVagao()
    } catch (e) {
      console.error(e)
    } finally {
      setShowReason(false)
      setLoading(false)
      await getConfirmedWagon(status, selectedFurnace)
    }
  }

  const modalObs = (item, itemkey) => {
    setCurrentItem(item);
    setCurrentItemKey(itemkey);
    setShowObs(true);
  };

  return (
    <>
      <Modal onHide={() => { setShowApont(false); setapontButtonEnabled(true) }} size="lg" show={showApont} >
        <Modal.Body className="p-0">
          <div className="table-fixed">
            <table className="table text-center">
              <thead>
                <tr>
                  <th>OP</th>
                  <th>PEÇA</th>
                  <th>VEÍCULO</th>
                  <th>PRODUTO</th>
                  <th>APROVADO</th>
                  <th>ANÁLISE GSA</th>
                </tr>
              </thead>
              <tbody>
                {vagaoItens.map((item, itemkey) => (
                  <>
                    <tr
                      key={`vagaoItens-${itemkey}`}
                    >
                      <td>{item.ordem_Serial}</td>
                      <td>{item.ordem_Part_Short}</td>
                      <td>{item.ordem_VehDesc}</td>
                      <td>{item.subProduto_Desc}</td>
                      <td>
                        <input
                          disabled={item.status_Peca === "APROVADO"}
                          defaultChecked={item.status_Peca === "FINALIZADO" || item.status_Peca === "APROVADO"}
                          id={`${item.ordem_Serial}-${itemkey}-APROVADO`}
                          ref={inputAPROVADO.current[itemkey]}
                          value="APROVADO"
                          type="radio"
                          className="input-radio"
                          onChange={({ target }) => {
                            handleRadio(target, itemkey, item)
                          }}
                        />
                      </td>
                      <td>
                        <input
                          // disabled={item.status_Peca === "ANALISE"}
                          defaultChecked={item.status_Peca === "ANALISE"}
                          id={`${item.ordem_Serial}-${itemkey}-ANALISE`}
                          ref={inputANALISE.current[itemkey]}
                          value="ANALISE"
                          type="radio"
                          className="input-radio"
                          onChange={({ target }) => {
                            handleRadio(target, itemkey, item)
                            modalObs(item, itemkey)
                          }}
                        />
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-0">

          <Button
            disabled={disableButton}
            className="m-2"
            variant="contained"
            onClick={() => {
              apontLote()
              setShowApont(false)
            }}
          >
            Apontar Vagão
          </Button>

        </Modal.Footer>

      </Modal>

    </>
  );

}
